import React, { useState } from 'react';

export function AddPartnersModal({ onClose, onSelect, existingPartners, availablePartners }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPartners, setSelectedPartners] = useState([]);

  // Filter out existing partners and apply search term
  const filteredPartners = availablePartners
    .filter(partner => !existingPartners.includes(partner.id))
    .filter(partner =>
      partner.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

  const handlePartnerToggle = (partnerId) => {
    setSelectedPartners(prev => {
      if (prev.includes(partnerId)) {
        return prev.filter(id => id !== partnerId);
      }
      return [...prev, partnerId];
    });
  };

  const handleSubmit = () => {
    onSelect(selectedPartners);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content add-channel-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add Partners</h2>
          <div className="search-container">
            <input
              type="text"
              placeholder="Search partners..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            <span className="search-icon">🔍</span>
          </div>
        </div>
        
        <div className="channels-container">
          {filteredPartners.length === 0 ? (
            <div className="no-channels-message">
              No partners available to add
            </div>
          ) : (
            filteredPartners.map(partner => (
              <div key={partner.id} className="channel-option">
                <label className="channel-label">
                  <input
                    type="checkbox"
                    checked={selectedPartners.includes(partner.id)}
                    onChange={() => handlePartnerToggle(partner.id)}
                  />
                  <span>
                    {partner.name}
                    {' '}
                    {partner.isDeal && (
                      <span className="deal-badge">
                        <span role="img" aria-label="flag">🚩</span>
                        {' '}
                        Orion Deal
                      </span>
                    )}
                  </span>
                </label>
              </div>
            ))
          )}
        </div>

        <div className="modal-actions">
          <button 
            type="button" 
            className="button-secondary" 
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            type="button" 
            className="button-primary"
            onClick={handleSubmit}
            disabled={selectedPartners.length === 0}
          >
            Add Selected Partners
          </button>
        </div>
      </div>
    </div>
  );
} 